<template>
  <div class="border-t border-gray-200/50 pt-8 dark:border-gray-700/50">
    <div class="flex flex-col items-center justify-between gap-4 md:flex-row">
      <div class="text-center text-gray-600 dark:text-gray-400 md:text-left">
        &copy; {{ copyrightDate }}
        <a
          href="https://github.com/vedmant"
          target="_blank"
          rel="noopener noreferrer"
          class="font-medium text-ternary-dark transition-colors duration-300 hover:text-accent dark:text-ternary-light dark:hover:text-accent"
        >{{ projectName }}</a>
        . All rights reserved.
      </div>

      <div class="flex items-center gap-6 text-sm text-gray-600 dark:text-gray-400">
        <span>Built with ❤️ using Vue.js & Nuxt</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const projectName = 'Vedware'
const copyrightDate = new Date().getFullYear()
</script>
